import qs from "../utils/qs";

const TO_PERSONAL_ACCOUNT = 75;
const TO_COMPANY_ACCOUNT = 74;
const BankList = qs.allBankList();
const selectedBankId = (openAccountBank) => {
    let index = -1;
    BankList.forEach((bank, idx) => {
        if (bank.name === openAccountBank) {
            index = idx;
        }
    });
    return index > -1 ? BankList[index]['id'] : OTHER_BANK_ID;
};
const OTHER_BANK_ID = 0;
export {TO_COMPANY_ACCOUNT, TO_PERSONAL_ACCOUNT, selectedBankId, OTHER_BANK_ID}